import './new-package-transport.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormPackageTransport from "../form-package-transport/form-package-transport";
import { useNewPackageTransport } from './new-package-transport.hook';

export function NewPackageTransport() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewPackageTransport();

  return (
    <div id="NewPackageTransport" className="package-transport">
      <HeaderContent
        title={<h1>New Package Transport</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormPackageTransport />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewPackageTransport;